import { render, staticRenderFns } from "./NvLabel.vue?vue&type=template&id=7ef845f8&scoped=true&"
import script from "./NvLabel.vue?vue&type=script&lang=js&"
export * from "./NvLabel.vue?vue&type=script&lang=js&"
import style0 from "./NvLabel.vue?vue&type=style&index=0&id=7ef845f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef845f8",
  null
  
)

export default component.exports